const enrichParastorageUrl = (
  parastorageUrl: string,
  cacheBuster: string,
  dependenciesToken: string,
) => {
  return parastorageUrl
    .replace('v_metaSiteId', `${cacheBuster}_metaSiteId`)
    .replace('depToken_', `depToken_${dependenciesToken}`);
};

const enrichLegacyUrl = (baseUrl: string, extraParams: URLSearchParams) => {
  const extraQueryParams = Object.keys(extraParams)
    .reduce(
      (acc, key) => [...acc, `${key}=${extraParams[key]}`],
      [] as string[],
    )
    .join('&');

  const delimeter = baseUrl.includes('?') ? '&' : '?';

  return `${baseUrl}${delimeter}${extraQueryParams}`;
};

export { enrichLegacyUrl, enrichParastorageUrl };
